import { Directive } from '@angular/core';

@Directive({
  selector: '[appCustomDatatable]',
})
export class CustomDatatableDirective {
  constructor() {}
}
